// extracted by mini-css-extract-plugin
export var buttons = "header-module--buttons--dc50a";
export var capsules = "header-module--capsules--c9d01";
export var globeIcon = "header-module--globeIcon--9526d";
export var header = "header-module--header--39aed";
export var icon = "header-module--icon--56a26";
export var logo = "header-module--logo--7dfe7";
export var menus = "header-module--menus--eef91";
export var navMenu = "header-module--navMenu--a486a";
export var searchIcon = "header-module--searchIcon--5748e";